<div class="flex flex-col w-full min-h-screen">
    <app-rotate-prompt *ngIf="isMobile || isTablet"></app-rotate-prompt>
    <router-outlet></router-outlet>
</div>
